import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Text = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #474d66;

  &.label {
    font-size: 14px;
    font-weight: 500;
    color: #1b203a;

    margin-left: 16px;
  }

  &.description {
    font-size: 14px;
    font-weight: 400;
    color: #474d66;
  }

  &.small-description {
    font-size: 14px;
    font-weight: 275;
    font-style: italic;
  }
`;

export const Button = styled.button`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 0;
  background-color: #fff;

  margin-top: 12px;
`;

interface IDivider {
  height: string;
}

export const Divider = styled.div<IDivider>`
  height: ${({ height }) => height};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;

  margin-bottom: 8px;
`;

interface ICheckbox {
  active: boolean;
}

export const Checkbox = styled.div<ICheckbox>`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  border: ${({ active }) =>
    active ? '4px solid #1371fe' : '1px solid #d8dae5'};
  background-color: #fff;
  transition: 0.2s;
`;

export const ListDiv = styled.div`
  display: flex;
  margin-left: 2rem;
  margin-bottom: -5px;
  list-style-type: circle;
  color: #474d66;
  font-size: 14px;
  font-weight: 400;
  text-align: left;

  ul,
  li {
    color: #474d66;
    font-size: 14px;
    font-weight: 400;
  }
`;
